/**
 * It takes a number of minutes and returns a string in the format "HH:MM" where HH is the number of
 * hours and MM is the number of minutes.
 * @param {number} totalMinutes - number
 * @returns A string with the hours and minutes.
 */
export const toHoursAndMinutes = (totalMinutes: number): string => {
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);

  return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}`;
};

/**
 * It takes a number and returns a string that is the number padded with a leading zero if the number
 * is less than 10
 * @param {number} num - number - The number to pad
 * @returns A function that takes a number and returns a string.
 */
export const padTo2Digits = (num: number): string => {
  return num.toString().padStart(2, '0');
};
